import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import React, { CSSProperties, FunctionComponent, useState } from 'react';
import { Button } from 'rs-emd-ui-atoms';
import { IHeroBannerWidget } from '../../../../models/campaign-pages/widgets/hero-banner/hero-banner.model';
import HeroBanner from '../hero-banner/hero-banner-component';
import styles from './hero-banner-carousel-component.module.scss';

export type HeroBannerCarouselProps = { widget: IHeroBannerWidget };

export const HeroBannerCarousel: FunctionComponent<HeroBannerCarouselProps> = (props: HeroBannerCarouselProps) => {
  let [index, setIndex] = useState(0);

  function getBanners() {
    return props.widget.banners.map((b, index) => {
      return (
        <div
          className={`${styles['hero-banner-carousel-container']} ${styles['banner-type-' + b.mobileContentStyle]}`}
          style={
            {
              '--content-container-border-height': b.mobileOverlayColour === 'white' ? '0px' : '8px',
            } as CSSProperties
          }>
          <HeroBanner
            banner={b}
            isInCarousel={true}
            numOfBannersInCarousel={props.widget.banners.length}
            currentCarouselIndex={index}
            setCarouselIndex={setCarouselIndex}
          />

          {/* more than one banner? show CTAs */}
          {props.widget.banners.length > 1 && (
            <>
              {/** left arrow */}
              <Button
                className={`${styles.arrow} ${styles.left}`}
                buttonType='text'
                icon='chev-left'
                onClick={() => setIndex(index - 1)}
                disabled={index === 0}
              />

              {/** right arrow */}
              <Button
                className={`${styles.arrow} ${styles.right}`}
                buttonType='text'
                size='full-width'
                icon='chev-right'
                onClick={() => setIndex(index + 1)}
                disabled={index === props.widget.banners.length - 1}
              />
            </>
          )}
        </div>
      );
    });
  }

  return (
    <div className={styles['carousel-container']}>
      <Carousel className={styles.carousel} value={index} slides={getBanners()} onChange={onSlideChange} />
    </div>
  );

  function setCarouselIndex(index: number) {
    setIndex(index);
  }

  function onSlideChange(index: number) {
    setIndex(index);
  }
};

HeroBannerCarousel.defaultProps = {};

export default HeroBannerCarousel;
